<template>
  <div id="payment-policy">
    <div class="grid">
      <div class="grid-title">
        <h4>{{ $t("PAYMENT_POLICY") }}</h4>
        <v-btn color="primary" class="pl-10 pr-10" @click="addPayment">
          <v-icon dark>
              mdi-plus
          </v-icon>
          {{ $t("ADD_NEW") }}
        </v-btn>
      </div>
      <div class="grid-body p-3 pb-0">
        <v-progress-linear
          color="warning"
          indeterminate
          rounded
          height="3"
          v-if="isLoading"
        ></v-progress-linear>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="header in headers" :class="header.class">
                  <div>
                    {{ header.text }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="!isLoading && dataTable.length > 0">
                <tr v-for="(item, i) in dataTable">
                  <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                  <td class="font-weight-bold vertical-middle">
                    <a
                      class="app-link text-decoration-none"
                      href="javascript:;"
                      @click="editItem(item)"
                    >
                      {{ item.nameVi }}
                    </a>
                  </td>
                  <td class="svertical-middle">
                    <span v-if="item.depositI18n.length > 0" >{{item.depositI18n.find(x => x.lang == defaultI18n).description}}</span>
                    <!-- <template v-if="systemLang == 'vi'">
                      Đặt cọc
                      <template v-if="item.chargeType == 0">
                        {{ item.amount }} đêm
                      </template>
                      <template v-else-if="item.chargeType == 1">
                        {{ item.amount }} %
                      </template>
                      <template v-else="item.chargeType == 2">
                        {{ _formatCurrency(item.amount) }} {{ currency}}
                      </template>
                      trước
                      {{ item.cutOfDate }} 
                      <template v-if="item.fromCheckout">
                        {{ $t("CHECKOUT_DATE" ) }}
                      </template>
                      <template v-else>
                        {{ $t("CHECKIN_DATE" ) }}
                      </template>
                    </template>
                    <template v-else>
                      Deposit {{ item.amount }}
                      <template v-if="item.chargeType == 0">
                        night
                      </template>
                      <template v-else-if="item.chargeType == 1">
                        %
                      </template>
                      <template v-else="item.chargeType == 2">
                        {{ currency}}
                      </template>
                      before
                      {{ item.cutOfDate }} 
                      <template v-if="item.fromCheckout">
                        {{ $t("CHECKOUT_DATE" ) }}
                      </template>
                      <template v-else>
                        {{ $t("CHECKIN_DATE" ) }}
                      </template>
                    </template> -->
                  </td>
                  <td class="text-center vertical-middle">
                    <div class="d-flex justify-center">
                      <v-switch
                        v-model="item.status"
                        class="item-switch m-0 p-0"
                        @change="changeStatus(item)"
                      ></v-switch>
                    </div>
                  </td>
                  <td class="text-center vertical-middle">
                    <v-tooltip top transition="slide-y-reverse-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          @click="editItem(item)"
                          x-small
                          class="rounded-sm mr-1"
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          outlined
                        >
                          <v-icon size="15">
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      {{ $t("EDIT") }}
                    </v-tooltip>
                    <v-tooltip top transition="slide-y-reverse-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          color="error"
                          @click="$refs.deleteDialogComponent.open(item)"
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          class="rounded-sm"
                          outlined
                        >
                          <v-icon size="15">
                            delete
                          </v-icon>
                        </v-btn>
                      </template>
                      {{ $t("DELETE") }}
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                    {{ $t('NO_DATA') }}
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>

        <paging
          v-if="paging.total"
          :paging.sync="paging"
          @changePage="changePage"
        >
          <span slot="totalItems" v-if="paging"
            >{{ $t("TOTAL") }}: {{ paging.total }}
            {{ $t("POLICY") }}</span
          >
        </paging>
      </div>
    </div>
    <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
      <span slot="title">{{ $t("CONFIRM_DELETE_POLICY") }}?</span>
    </delete-dialog>
  </div>
</template>

<script>
import AddPolicy from "./AddPolicy.vue";
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { _formatDate, _alert, _formatCurrency } from "@/_helpers/function.js";
import { service } from "@/_services/HotelSetting/payment-policy.service.js";
export default {
  components: {
    "add-policy": AddPolicy,
    paging: Paging,
    "delete-dialog": DeleteDialog
  },
  data() {
    return {
      currency: this.usedCurrency,
      isLoading: true,
      systemLang: this.$i18n.locale,
      isListingPage: true,
      headers: [
        {
          text: this.$t("STT"),
          class: "left",
          value: "stt"
        },
        {
          text: this.$t("POLICY_NAME"),
          class: "left",
          value: "name"
        },
        {
          text: this.$t("POLICY_DESCRIPTION"),
          class: "left",
          value: "detail"
        },
        {
          text: this.$t("STATUS"),
          class: "text-center",
          value: "detail"
        },
        { text: this.$t("ACTION"), value: "action", sortable: false }
      ],
      data: [],
      editedIndex: -1,
      dataTable: [],
      editedItem: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      totalItems: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
     initialize(params) {
      if (!params) {
        params = {
          limit: 15,
          offset: 0
        };
      }
      this.isLoading = true;
      service.get(params).then(res => {
        this.data = res.data;
        // this.totalItems = res.total;

        this.paging.total = res.total;
        this.dataTable = res.data;
      }).finally(() => (this.isLoading = false));;
    },
    addPayment() {
      this.$router.push({ name: "editPaymentPolicy", params: { id: 0 } });
    },
    changePage(paging) {
      this.paging = paging;
      let params = {
            limit: 15,
            offset: this.paging.offset
        };
      this.initialize(params);
    },
    editItem(item) {
      this.$router.push({ name: "editPaymentPolicy", params: { id: item.id } });
    },
    changeStatus(item) {
      service.update(item).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      service.remove(item.id).then(res => {
        let message;
        if (res.responseCode == 0) {
          this.totalItems -= 1;
          let params = {
            limit: 15,
            offset: this.paging.offset
          };
          this.initialize(params);
        }
        _alert(res, this.$t(res.data), false);
        this.$refs.deleteDialogComponent.close();
      });
    },

    save(item) {
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], item);
      } else {
        this.data.push(item);
        this.initialize();
      }
      this.isListingPage = true;
    },
    redirect() {
      this.isListingPage = !this.isListingPage;
    },
    _formatCurrency: _formatCurrency
  }
};
</script>